<!--简历无资料的时候-->
<template>
	<div class="no-data-content">
		<h3 class="title" v-if="showTitle===false?false:true">{{blockText}}</h3>
		<a href="javascript:;" class="bar-edit" :class="{'disabled':!editable}" :title="!editable?'已完成或已退款的订单不能进行此操作':''" @click="firstAdd">+{{blockText}}</a>
	</div>
</template>

<script>
	export default {
		name: 'UndoneTemplate',
		props: {
			blockText: {
				type: String,
				required: true
			},
			showTitle: {
				type: Boolean,
				required: false
			},
			editable: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {
				status: 0
			}
		},
		methods: {
			firstAdd() {
				if(!this.editable) return;
				this.$emit('editBtnClick');
			}
		}
	}
</script>

<style scoped lang='less'>
	.no-data-content {
		width: 100%;
		.title {
			position: relative;
			color: #333;
			font-size: 18px;
			font-weight: 600;
			margin-bottom: 20px;
			padding-left: 20px;
			&::before {
				content: "";
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				margin: auto 0;
				width: 4px;
				height: 16px;
				background: rgba(155, 162, 252, 1);
				background: linear-gradient(0deg, rgba(111, 121, 238, 1), rgba(155, 162, 252, 1));
				background: -moz-linear-gradient(top, rgba(111, 121, 238, 1), rgba(155, 162, 252, 1));
				background: -o-linear-gradient(top, rgba(111, 121, 238, 1), rgba(155, 162, 252, 1));
			}
		}
		.bar-edit {
			display: block;
			line-height: 40px;
			margin-bottom: 30px;
			text-align: center;
			color: #333;
			background: rgba(249, 249, 249, 1);
			border-radius: 2px;
			border: 1px dashed #eee;
			&.disabled {
				cursor: not-allowed;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeUndoneTemplate.vue